// 豆包没有任何可用的外部深链方案（/pdf/ 深链需 doc_id、chat 预填参数全部失效），
// 故采用实测可靠的方案：复制提示词到剪贴板 + 打开豆包 chat，用户粘贴发送即可。
import { copyText, showToast } from './ui';

export async function openInDoubao(pdfUrl) {
  const copied = await copyText(`阅读并翻译这篇论文：${pdfUrl}`);
  window.open('https://www.doubao.com/chat/', '_blank', 'noopener');
  showToast(
    copied ? '已复制提示词，到豆包里粘贴发送即可' : '复制失败，请手动把论文链接发给豆包',
    copied
  );
}
